import React from 'react'

export const IconMustSee = () => {
  return (
    <svg width="18" height="26" viewBox="0 0 18 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.7252 25.236C4.01338 24.8569 1.88039 21.9082 1.69198 18.6072C1.39686 13.4365 5.21047 12.2988 6.96783 9.27015C8.37373 6.84724 8.25163 3.92328 8.01485 2.76416C9.32352 4.14762 11.3453 5.80988 12.5079 8.13043C13.6706 10.451 14.1661 12.502 13.1374 15.664M8.7252 25.236C11.7472 25.236 15.8039 23.5669 16.5025 19.59C16.9246 17.1876 16.5025 14.2057 16.0165 13.2336C15.9292 13.5701 15.5453 14.4151 14.7078 15.1031M8.7252 25.236C14.7085 24.2006 12.3522 19.9265 10.707 17.9074C9.39082 16.2921 9.33598 14.7666 9.47308 14.2057C8.638 14.8788 6.96783 16.5614 6.96783 17.9074M8.7252 25.236C6.50137 24.9207 5.7209 23.7595 5.27221 22.4135C4.91326 21.3366 5.3601 19.59 5.65923 19.1039C5.80875 19.5526 6.27979 20.4949 6.96783 20.6743"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  )
}
